import { createAction } from 'redux-act';

export const requestFabricDismissMessage = createAction('Fabric request to dismiss a user message', (messageId) => ({messageId}));
